import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { Control, FieldValues, Controller } from "react-hook-form";
import { IOption } from "../../const/types/editBookingTypes";

interface FormInputProps {
  name: string;
  control: Control<FieldValues>;
  label: string;
  options: IOption[];
  classes: {
    formControl: string;
    inputLabelAndMenuItems: string;
  };
  selectId: string;
  labelId: string;
  error: boolean;
  trigger?: () => void;
}

export const ReactHookFormSelect: React.FC<FormInputProps> = ({
  name,
  control,
  label,
  options,
  classes,
  selectId,
  labelId,
  error,
  trigger,
}) => {
  function convertStringToBoolean(value: string) {
    if (value === "false") return false;
    if (value === "true") return true;
    return value;
  }
  const outOfRangeValue = (value: string): boolean => {
    const lastValue = convertStringToBoolean(value);
    if (options.filter((option) => option.value === lastValue).length <= 0) {
      return true;
    } else {
      return false;
    }
  };

  const deepClone = (obj: unknown) => {
    return JSON.parse(JSON.stringify(obj));
  };

  const generateSingleOptions = (value: string) => {
    const tmpOptions = deepClone(options);
    if (outOfRangeValue(value))
      if(value !== null && value !== undefined && value !== "null" && value !== "")
      tmpOptions.push({
        label: value + " is unknown value.",
        value: value,
      });
    return Object(tmpOptions).map((option: IOption) => {
      return (
        <MenuItem
          key={option.label}
          className={classes.inputLabelAndMenuItems}
          value={String(option.value)}
        >
          {option.label}
        </MenuItem>
      );
    });
  };

  return (
    <FormControl className={classes.formControl}>
      <InputLabel id={labelId} className={classes.inputLabelAndMenuItems}>
        {label}
      </InputLabel>
      <Controller
        render={({ field: { onChange, value } }) => (
          <Select
            id={selectId}
            labelId={labelId}
            label={label}
            error={error}
            onChange={(e: SelectChangeEvent<string>) => {
              onChange(convertStringToBoolean(e.target.value));
              if (trigger !== undefined) {
                trigger();
              }
            }}
            value={value}
          >
            {/*"false"*/}
            {generateSingleOptions(value)}
          </Select>
        )}
        control={control}
        name={name}
      />
    </FormControl>
  );
};
